import moment from 'moment'
import {t} from './translate.js'

// returns a policy's status based on effective date, expiry_date, active and status

export function getStatusText(props) {
  const effDate = props.data.getIn(props.args.key_paths.effective_date);
  const expDate = props.data.getIn(props.args.key_paths.expiry_date);
  const isActive = props.data.getIn(props.args.key_paths.is_active);
  const status = props.data.getIn(props.args.key_paths.status);

  return getStatus(effDate, expDate, isActive, status);
}

export function getStatus(effDate, expDate, isActive, status) {
  const effectiveDate = moment(effDate);
  const expiryDate = moment(expDate).endOf('day');
  const today = moment();

  if (isActive === true) {
    if (today.isAfter(expiryDate)) {
      return t('Expired');
    } else if (today.isBefore(effectiveDate)) {
      return t('Sold');
    } else {
      return t('Active');
    }
  } else if (isActive === false) {
    switch (status) {
      case 'sold':
        return t('Sold');
      case 'pending payment':
        return t('Incomplete Application');
      case 'cancelled':
        return t('Cancelled');
      case 'void':
        return t('Void');
      default:
        return t(status)
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/getStatusText.js